var _rect, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearpass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 150,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fill: "#FF8300",
    fontWeight: "bold"
  }, "\n    aruba\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#606060"
  }, "\n    a Hewlett Packard Enterprise company\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearpass);
export default __webpack_public_path__ + "static/media/clearpass.0f4477ad26c95ad95e7817c22d95d2aa.svg";
export { ForwardRef as ReactComponent };